// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3SPiK","fileBtn":"File_fileBtn__2cHzN","closeBtn":"File_closeBtn__2O4WP","fileSelected":"File_fileSelected__27Np8","disabled":"File_disabled__10JY9"};